/** Deterministic scattered logo placements for watermark backgrounds */
export const logoWatermarkItems = [
  { top: "6%", left: "4%", size: 64, rotate: -22 },
  { top: "11%", left: "22%", size: 92, rotate: 14 },
  { top: "8%", left: "48%", size: 56, rotate: -8 },
  { top: "14%", left: "72%", size: 110, rotate: 18 },
  { top: "5%", left: "91%", size: 70, rotate: -15 },
  { top: "28%", left: "8%", size: 118, rotate: 11 },
  { top: "34%", left: "34%", size: 74, rotate: -28 },
  { top: "26%", left: "58%", size: 96, rotate: 6 },
  { top: "31%", left: "84%", size: 62, rotate: -12 },
  { top: "52%", left: "3%", size: 88, rotate: 20 },
  { top: "48%", left: "26%", size: 58, rotate: -6 },
  { top: "55%", left: "50%", size: 104, rotate: -18 },
  { top: "50%", left: "74%", size: 68, rotate: 24 },
  { top: "58%", left: "93%", size: 82, rotate: -10 },
  { top: "72%", left: "12%", size: 72, rotate: 16 },
  { top: "78%", left: "38%", size: 100, rotate: -14 },
  { top: "70%", left: "62%", size: 60, rotate: 8 },
  { top: "76%", left: "86%", size: 90, rotate: -20 },
  { top: "90%", left: "6%", size: 54, rotate: 12 },
  { top: "88%", left: "44%", size: 86, rotate: -24 },
  { top: "92%", left: "68%", size: 66, rotate: 5 },
  { top: "86%", left: "88%", size: 78, rotate: -16 },
];
